import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import { IoMdClose } from 'react-icons/io'

const Container = styled.div`
  button {
    border-radius: 50px;
    background: #ffffff;
    color: #8e8fc7;
    padding: 1.3em 4em;
    border: none;
    text-transform: uppercase;
    cursor: pointer;
  }
`

export default function ModalCompontent({ url }) {
  const [modalIsOpen, setIsOpen] = useState(false)

  Modal.setAppElement('body')

  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
  }
  const customStyles = {
    content: {
      width: '60%',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: '50px 10px 5px',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  }

  return (
    <Container>
      <button type="button" onClick={openModal}>
        Acessar o Tour
      </button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Tour Virtual"
      >
        <button type="button" onClick={closeModal}>
          <IoMdClose size="1.2em" />
        </button>
        <iframe
          title="Tour"
          src={url}
          width="100%"
          height="450"
          frameBorder="0"
          allowFullScreen
        />
      </Modal>
    </Container>
  )
}
